/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { TrickPlayManager } from "./TrickPlayManager";
export {
  EmulatedTrickplayControlImpl,
  IFrameTrickplayControlImpl,
  ThumbnailTrickplayControlImpl
} from "./impls";
export { Direction, SpeedLevel, TrickPlayMode } from "../enums";
export type {
  ITrickPlayControl,
  ITrickPlayConfig,
  ITrickPlayEligibility,
  SeekRangeMode
} from "../interfaces";
export { SPEED_VALUE } from "../types";
export {
  DEFAULT_ELIGIBILITY,
  DISABLED_ELIGIBILITY,
  DEFAULT_TRICKPLAY_CONFIG,
  LIVE_THRESHOLD_SECONDS,
  LONG_PRESS_THRESHOLD_MS,
  MIN_TIMESHIFT_WINDOW_SECONDS,
  SPEED_ESCALATION_MS,
  RESTRICTION_API_TIMEOUT_MS,
  SEEK_BACKWARD_STEP,
  SEEK_FORWARD_STEP,
  TRICK_PLAY_BOUNDARY_THRESHOLD
} from "./constants";
export { deriveEligibility, parseTrickModeRestrictions } from "./eligibility";
export type {
  ITrickModeRestrictions,
  ITrickPlaySessionFlags
} from "./eligibility";
